/**
 * Stage detection — identifica em qual ambiente de deploy o frontend está rodando.
 *
 * Os 3 estágios compartilham o mesmo backend Supabase. A diferenciação é puramente
 * visual (badge no menu) e baseada no hostname público.
 *
 * Convenções de hostname:
 *   - creditos.invenia.com.br        → "producao"
 *   - creditos-beta.invenia.com.br   → "beta"
 *   - creditos-alfa.invenia.com.br   → "alfa"
 *   - localhost / 127.0.0.1          → "local"
 *   - *.creditos-v2.pages.dev        → "preview" (CF Pages branch deploy direto)
 *   - qualquer outro                 → "producao" (fallback seguro: nada de banner)
 */
export type Stage = "producao" | "beta" | "alfa" | "local" | "preview"

export function detectStage(hostname?: string): Stage {
  // SSR-safe: window pode não existir
  const host = (hostname ?? (typeof window !== "undefined" ? window.location.hostname : ""))
    .toLowerCase()

  if (host === "creditos.invenia.com.br") return "producao"
  if (host === "creditos-beta.invenia.com.br") return "beta"
  if (host === "creditos-alfa.invenia.com.br") return "alfa"
  if (host === "localhost" || host === "127.0.0.1" || host.endsWith(".local")) return "local"
  if (host.endsWith(".creditos-v2.pages.dev")) return "preview"
  return "producao"
}

/**
 * Define se o stage atual deve mostrar uma badge visual ao lado do logo.
 * Produção (URL oficial) não mostra nada — usuário final não vê marcas de stage.
 */
export function shouldShowStageBadge(stage: Stage): boolean {
  return stage === "alfa" || stage === "beta" || stage === "local" || stage === "preview"
}
